export const WillCheckingStatus = {
  Checking: 'checking',
  Failed: 'failed',
  Passed: 'passed',
  Waiting: 'waiting',
}
